/**
 * 레이아웃 각 영역의 표시 여부를 관리하는 Custom Hook
 * Single Responsibility: UI 영역별 표시 조건만 담당
 */ import { useMemo } from 'react';
export const useLayoutVisibility = (options)=>{
    const { variant = 'standard', hideNavigation = false, showRightSidebar = false, showChatSidebar = false, renderSidebar, renderRightSidebar, renderMobileNavigation, isMobileView = false, isTabletView = false, isDesktopView = true } = options;
    const visibility = useMemo(()=>{
        const isSimpleMode = variant === 'simple';
        // 🎯 각 영역별 표시 조건을 명확하게 분리
        const shouldShowSidebar = !hideNavigation && !!renderSidebar && !isMobileView; // 모바일에서는 완전히 숨김
        const shouldShowRightSidebar = !isSimpleMode && !isMobileView && (showRightSidebar || showChatSidebar) && !!renderRightSidebar;
        const shouldShowMobileNavigation = isMobileView && !!renderMobileNavigation;
        console.log('🔵 useLayoutVisibility - mobileNavigation check:', {
            isMobileView,
            hasRenderMobileNavigation: !!renderMobileNavigation,
            shouldShowMobileNavigation
        });
        // 🎨 레이아웃 모드별 조건
        const layoutModes = {
            hasSidebar: shouldShowSidebar,
            hasRightSidebar: shouldShowRightSidebar,
            hasMobileNavigation: shouldShowMobileNavigation,
            isSimpleLayout: isSimpleMode,
            isResponsiveLayout: isMobileView || isTabletView
        };
        return {
            sidebar: shouldShowSidebar,
            rightSidebar: shouldShowRightSidebar,
            mobileNavigation: shouldShowMobileNavigation,
            modes: layoutModes
        };
    }, [
        variant,
        hideNavigation,
        showRightSidebar,
        showChatSidebar,
        renderSidebar,
        renderRightSidebar,
        renderMobileNavigation,
        isMobileView,
        isTabletView,
        isDesktopView
    ]);
    return visibility;
};
